/**
 * InlinePriceHint — Wrapper léger utilisant usePriceCheck pour afficher
 * une alerte prix sous un input dans un formulaire de dépense.
 */
import React from "react";
import usePriceCheck from "./usePriceCheck";
import PriceAlert from "./PriceAlert";

export default function InlinePriceHint({ description, unitPrice, supplier = "", threshold = 0.2 }) {
  const { data, alert } = usePriceCheck({ description, unitPrice, supplier, threshold });
  if (!description || description.trim().length < 3) return null;
  return <PriceAlert alert={alert} historicalCount={data?.count || 0} />;
}
